import template from './basketButton.html';

const component = {
	template,
	transclude: true,
	bindings: {
		product:'=',
		modal:'<',
		max:'<',
		service:'<',
		parent:'='
	},
	controller: function(
		$filter, 
		$ionicLoading,
		$ionicModal,
		$ionicPopup,
		$rootScope, 
		$q,
		$scope, 
		Basket, 
		Customer,
		growl,
		Product, 
	) {
		'ngInject'

		var vm = this;
		vm.count = Basket.count(vm.product.id);
		vm.loading = false;

		var addProduct = function() {
			vm.loading = true;
			Basket.add(vm.product.id, {
				parent_id: vm.parent
			}).then(function() {
				growl.success($filter('translate')('growl_basket_product_added'));
				if(vm.modal) {
					return Product.get(vm.product.id, {
						include: 'accessories,services'
					}).then(function(res) {
						if ((res.accessories && res.accessories.length > 0) || (res.services && res.services.length > 0)) {
							$scope.product = res;
							$scope.modal = $ionicModal.fromTemplate('<upsell modal="modal" product="product"></upsell>', {
								scope: $scope,
								animation: 'slide-in-up'
							});
							$scope.modal.show();
						}
					})
				} else {
					return $q.resolve();
				}
			}).catch(function(err) {
				console.log(err);
			}).finally(() => {
				vm.loading = false;
			});
		}

		vm.add = function() {
			if(!Customer.session()) {
				Customer.create().then(function() {
					growl.info($filter('translate')('growl_automatic_customer_session_created'));
					addProduct();
				});
			} else {
				addProduct();
			}
		}

		vm.remove = function() {
			vm.loading = true;
			Basket.remove(vm.product.id).finally(function() {
				vm.loading = false;
			});
		}

		$scope.$on('BASKET_CHANGED', function(e) {
			vm.count = vm.count = Basket.count(vm.product.id);
		});
	}
}

export default component


// WEBPACK FOOTER //
// ./app/components/basketButton/basketButton.component.js